/**
 * Created by denis.gusarov on 4/27/2017.
 */

namespace Factive.Game {
    import Tween = Factive.Core.Tween.Tween;
    import Easing = Factive.Core.Tween.Easing;
    import _ = Factive.Core.Underscore;
    import Rndm = Arkadium.Core.utils.Rndm;
    import List = Factive.Core.Linq.List;

    // let rndm:Rndm = new Rndm();
    // rndm.initialize(12);

    export interface IResultTableRowModel {
        name:string;
        x1:number;
        x2:number;
        x3:number;
    }

    export class DiceModel extends BaseModel {

        public value:number = 0;
        public color:number = 0;
        public interactive: boolean = false;
        public visible: boolean = false;

        public constructor() {
            super();
        }

        // public drop():number {
        //     this.visible = true;
        //     this.interactive = true;
        //     return this.value = rndm.integer(1,7);
        // }

        public set(value: number){
            this.visible = true;
            this.interactive = true;
            return this.value = value;
        }
    }

    export class GroupDiceModel extends BaseModel {

        public dicesList:List<DiceModel>;
        public dice0:DiceModel;
        public dice1:DiceModel;
        public dice2:DiceModel;
        public dice3:DiceModel;
        public dice4:DiceModel;

        public count:number = 0;

        public constructor() {
            super();

            this.dicesList = new List<DiceModel>([
                new DiceModel(),
                new DiceModel(),
                new DiceModel(),
                new DiceModel(),
                new DiceModel()
            ]);

            this.dice0 = this.dicesList.ElementAt(0);
            this.dice1 = this.dicesList.ElementAt(1);
            this.dice2 = this.dicesList.ElementAt(2);
            this.dice3 = this.dicesList.ElementAt(3);
            this.dice4 = this.dicesList.ElementAt(4);
        }

        // public drop(){
        //     this.dicesList.ForEach((dice, index)=>{
        //         dice.visible = false;
        //         dice.interactive = false;
        //     });
        //     this.dicesList.Take(this.count).ForEach((dice, index)=>{
        //         dice.drop();
        //     });
        // }

        public set(diceNumbersArray: Array<number>){
            this.dicesList.ForEach((dice, index)=>{
                dice.visible = false;
                dice.interactive = false;
            });
            this.dicesList.Take(this.count).ForEach((dice, index)=>{
                dice.set(diceNumbersArray[index]);
            });
        }

        public getDice(dice:DiceModel): DiceModel{
            return this.dicesList.FirstOrDefault(d => d == dice);
        }

        public showDice(value:number){
            let dice = this.dicesList.FirstOrDefault(d => d.visible == false);
            dice.visible = true;
            dice.interactive = true;
            dice.value = value;
            this.count++;
        }

        public hideDice(dice:DiceModel){
            //let dice = this._dicesList.FirstOrDefault(d => d.visible == false);
            dice.visible = false;
            dice.interactive = false;
            dice.value = 0;
            this.count--;
        }

        public prepareAll() {
            this.count = 5;
            this.dicesList.ForEach((dice, index)=>{
                dice.visible = false;
                dice.interactive = false;
            });
        }

        public clearAll() {
            this.count = 0;
            this.dicesList.ForEach((dice, index)=>{
                dice.visible = false;
                dice.interactive = false;
            });
        }
    }

    export class ResultTableModel {
        public rows: any = {};

        public constructor() {

            _.each(ScoreCombinationType, function (combinationType) {
                if(typeof combinationType != 'string'){
                    return;
                }
                this.rows[combinationType] = <IResultTableRowModel>{
                    name:combinationType,
                    x1:0,
                    x2:0,
                    x3:0,
                    isUsed:false
                }
            }, this);

        }

        // public rows: any = {
        //     Ones: <IResultTableRowModel>{
        //         name:"Ones",
        //         x1:0,
        //         x2:0,
        //         x3:0,
        //         isUsed:false
        //     },
        //     Twos: <IResultTableRowModel>{
        //         name:"Twos",
        //         x1:0,
        //         x2:0,
        //         x3:0,
        //         isUsed:false
        //     },
        //     Threes: <IResultTableRowModel>{
        //         name:"Threes",
        //         x1:0,
        //         x2:0,
        //         x3:0,
        //         isUsed:false
        //     }
        // }
    }

    export class GameDataModel extends BaseModel  {

        public resultTable: ResultTableModel = new ResultTableModel();
        public selectedDice: GroupDiceModel = new GroupDiceModel();
        public droppedDice: GroupDiceModel = new GroupDiceModel();
        private _scorePredictor: Factive.Game.ScorePredictor;

        public constructor(private _options) {
            super();
            this._scorePredictor = new ScorePredictor();
        }

        // public dropDices() {
        //     this.droppedDice.prepareAll();
        //     this.droppedDice.drop();
        // }

        public setDropDices(diceNumbersArray: Array<number>) {
            this.droppedDice.prepareAll();
            this.droppedDice.set(diceNumbersArray);

            this._calculate();
        }

        // public redropDices() {
        //     this.droppedDice.drop();
        // }

        public selectDice(selectedDice:DiceModel){
            let dice = this.droppedDice.getDice(selectedDice);
            if(dice){
                this.selectedDice.showDice(dice.value);
                this.droppedDice.hideDice(dice);
            }else{
                let dice = this.selectedDice.getDice(selectedDice);
                if(dice){
                    this.droppedDice.showDice(dice.value);
                    this.selectedDice.hideDice(dice);
                }
            }

        }

        private _calculate() {
            let keys = Object.keys(ScoreCombinationType);

            let totalDices:Array<DiceData> = this.selectedDice.dicesList
                .Where(d=> d.value > 0)
                .Concat(this.droppedDice.dicesList.Where(d=> d.value > 0))
                .Select(d => {
                let diceData = new DiceData();
                diceData.initialize(d.color, d.value);
                return diceData;
            }).ToArray();

            let l:number = keys.length*.5;
            for(let i:number = 0; i < l; i++)
            {

                let score = this._scorePredictor.calculate(totalDices, i);
                //console.log(totalDices,ScoreCombinationType[i],score);

                this.resultTable.rows[ScoreCombinationType[i]].x1 = score;
            }
        }
    }

}


// WEBPACK FOOTER //
// src/typescript/Game/Views/Game/GameDataModel.ts